<div class="component component--community community">
	<div class="wrapper">
		<div class="row">
			<div class="col-12 col-md-9">
				<section id="community__participants" class="component community-page component--community__participants community__participants" [ngClass]="filterButton?'is-filtering':''">
					<div class="community__participants-listing">
						<div class="intro-content">
							<h1 *ngIf="speakerData?.speaker_block_title != ''" [innerHtml]="speakerData?.speaker_block_title"></h1>
							<div class="filter-section">
								<div class="btn-group btn-group--tags menu-wrapper" ngbDropdown role="group" autoClose="outside" #tagDropSpeakers="ngbDropdown">
									<input type="hidden" id="closeTagsSpeakers" (click)="tagDropSpeakers.close();">
									<button type="button" class="btn btn-primary dropdown-toggle tags-button menu-handler" data-isclicked="0" data-toggle="dropdown" id="community-filter" ngbDropdownToggle>
										<b>Filter</b><b>Close</b> <span class="arrow arrow--down"><i class="icon-arrow-down"></i></span>
									</button>
									<ul ngbDropdownMenu class="dropdown-menu" aria-labelledby="community-filter">
										<li class="wrapper">
											<div class="filter-by">
												<div class="filter-by__repeater">
													<div class="row">
														<div class="col-12 col-sm-3"><strong>Org. type:</strong></div>
														<div class="col-12 col-sm-9">
															<ul class="tags-wrapper free-wrapper filter-type">
																<li class="alleventypes">
																	<a class="event-type__filter alltypes" [class.activated] = "orgtypeAll == true" href="javascript:;" (click)="filterMore( $event, 'orgtype', 0, 'all' )">All</a>
																</li>
																<li *ngFor="let orgVal of speakerOrgType">
																	<a class="event-type__filter alltypes {{ org_type_id == orgVal.Id ? 'activated' : '' }}" href="javascript:;" (click)="filterMore( $event, 'orgtype', orgVal.Id, orgVal.Name )">{{ orgVal.Name }}</a>
																</li>
															</ul>
														</div>
													</div>
												</div>
												<div class="filter-by__repeater">
													<div class="row">
														<div class="col-12 col-sm-3"><strong>Based in:</strong></div>
														<div class="col-12 col-sm-9">
															<ul class="tags-wrapper free-wrapper filter-type">
																<li class="alleventypes">
																	<a class="event-type__filter alltypes" [class.activated] = "continentAll == true" href="javascript:;" (click)="filterMore( $event, 'continent', 0, 'all' )">All</a>
																</li>
																<li *ngFor="let cVal of speakerContinents" class="{{ cVal.enabled == false ? 'disabled': ''}}">
																	<a class="event-type__filter {{ cVal.selected == true && cVal.enabled == true ? 'activated' : '' }}" href="javascript:;" (click)="filterMore( $event, 'continent', cVal.id, cVal.name )">{{ cVal.name }}</a>
																</li>
															</ul>
														</div>
													</div>
												</div>
												<div class="filter-by__repeater">
													<div class="row">
														<div class="col-12 col-sm-3"><strong>Young professional:</strong></div>
														<div class="col-12 col-sm-9">
															<ul class="tags-wrapper free-wrapper filter-type">
																<li class="alleventypes">
																	<a class="event-type__filter alltypes" [class.activated] = "professionalAll == true" href="javascript:;" (click)="filterMore( $event, 'professional', 0, 'all' )">All</a>
																</li>
																<li *ngFor="let pypVal of speakerYoungProfessional">
																	<a class="event-type__filter {{ professional_id == pypVal.Value ? 'activated' : '' }}" href="javascript:;" (click)="filterMore( $event, 'professional', pypVal.Value, pypVal.Key )">{{ pypVal.Key }}</a>
																</li>
															</ul>
														</div>
													</div>
												</div>
												<div class="filter-by__repeater">
													<div class="row">
														<div class="col-12 col-sm-3"><strong>Gender:</strong></div>
														<div class="col-12 col-sm-9">
															<ul class="tags-wrapper free-wrapper filter-type">
																<li class="alleventypes">
																	<a class="event-type__filter alltypes" [class.activated] = "genderAll == true" href="javascript:;" (click)="filterMore( $event, 'gender', 0, 'all' )">All</a>
																</li>

																<li *ngFor="let gVal of speakerGender">
																	<a class="event-type__filter {{ gender_id == gVal.Value ? 'activated' : '' }}" href="javascript:;" (click)="filterMore( $event, 'gender', gVal.Value, gVal.Key )">{{ gVal.Key }}</a>
																</li>
															</ul>
														</div>
													</div>
												</div>
												<div class="filter-by__repeater">
													<div class="row">
														<div class="col-12 col-sm-3"><strong>Open to interview:</strong></div>
														<div class="col-12 col-sm-9">
															<ul class="tags-wrapper free-wrapper filter-type">
																<li class="alleventypes">
																	<a class="event-type__filter alltypes" [class.activated] = "interviewAll == true" href="javascript:;" (click)="filterMore( $event, 'interview', 0, 'all' )">All</a>
																</li>
																<li *ngFor="let otiVal of speakerOpenToInterview">
																	<a class="event-type__filter {{ interview_name == otiVal.Key ? 'activated' : '' }}" href="javascript:;" (click)="filterMore( $event, 'interview', otiVal.Value, otiVal.Key )">{{ otiVal.Key }}</a>
																</li>
															</ul>
														</div>
													</div>
												</div>
												<div class="filter-by__repeater">
													<div class="row">
														<div class="col-12 col-sm-3"><strong>Available speaker:</strong></div>
														<div class="col-12 col-sm-9">
															<ul class="tags-wrapper free-wrapper filter-type">
																<li class="alleventypes">
																	<a class="event-type__filter alltypes" [class.activated] = "speakerAll == true" href="javascript:;" (click)="filterMore( $event, 'speaker', 0, 'all' )">All</a>
																</li>
																<li *ngFor="let pasVal of speakerAvailableSpeaker">
																	<a class="event-type__filter {{ speaker_name == pasVal.Key ? 'activated' : '' }}" href="javascript:;" (click)="filterMore( $event, 'speaker', pasVal.Value, pasVal.Key )">{{ pasVal.Key }}</a>
																</li>
															</ul>
														</div>
													</div>
												</div>
												<div class="filter-by__repeater">
													<div class="row">
														<div class="col-12 col-sm-3"><strong>Open to meeting request:</strong></div>
														<div class="col-12 col-sm-9">
															<ul class="tags-wrapper free-wrapper filter-type">
																<li class="alleventypes">
																	<a class="event-type__filter alltypes" [class.activated] = "meetingAll == true" href="javascript:;" (click)="filterMore( $event, 'meeting', 0, 'all' )">All</a>
																</li>
																<li *ngFor="let pomVal of speakerOpenToMeeting">
																	<a class="event-type__filter
																	{{ meeting_name == pomVal.Key ? 'activated' : '' }}" href="javascript:;" (click)="filterMore( $event, 'meeting', pomVal.Value, pomVal.Key )">{{ pomVal.Key }}</a>
																</li>
															</ul>
														</div>
													</div>
												</div>
											</div>
											<div class="filter-by-tags">
												<strong class="tags-header">Interested in:</strong>
												<ul class="tags-wrapper interested-in"> 
													<li class="alleventypes">
														<a class="event-type__filter alltypes" [class.activated] = "tagAll == true" href="javascript:;" (click)="filterMore( $event, 'tags', 0, 'all' )">All</a>
													</li>
													<li *ngFor="let tagVal of speakerTags" class="{{ tagVal.enabled == false ? 'disabled': ''}}">
														<a class="event-type__filter {{ tagVal.selected == true && tagVal.enabled == true ? 'activated' : '' }}" href="javascript:;" (click)="filterMore( $event, 'tags', tagVal.id, tagVal.name )">{{ tagVal.name }}</a>
													</li>
												</ul>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div class="filterButton__wrapper" *ngIf="filterButton">
							<span class="filterButton">
								<span class="loading__circle loading__circle-small" id="fitlerLoader"></span>
							</span>
						</div>
						<div class="filtered-text">
							<div class="default-filter default-filter show" *ngIf="noFilter == true ||
																	( showSelectedorgtype == false 
																		&& showSelectedcontinent == false
																		&& showSelectedjobtitle == false 
																		&& showSelectedprofessional == false
																		&& showSelectedgender == false
																		&& showSelectedinterview == false
																		&& showSelectedspeaker == false
																		&& showSelectedmeeting == false
																		&& showSelectedtag == false
																	)">
								<span class="filtered-by">All</span>
							</div>
							<div class="filter-by-selected selected__wrapper" *ngIf="noFilter == false && (  showSelectedorgtype == true 
								|| showSelectedcontinent == true
								|| showSelectedjobtitle == true 
								|| showSelectedprofessional == true
								|| showSelectedgender == true
								|| showSelectedinterview == true
								|| showSelectedspeaker == true
								|| showSelectedmeeting == true
								|| showSelectedtag == true )">
								<span class="filter-by-selected tag-title tagblock" *ngIf="noFilter == false && (  showSelectedorgtype == true 
								|| showSelectedcontinent == true
								|| showSelectedjobtitle == true 
								|| showSelectedprofessional == true
								|| showSelectedgender == true
								|| showSelectedinterview == true
								|| showSelectedspeaker == true
								|| showSelectedmeeting == true
								|| showSelectedtag == true )">Selected tag(s): </span>
								<div class="tags selected__tags tag_block" *ngIf="showSelectedtag == true">
									<span class="tagFilter btn" *ngFor="let ctVal of tag_list_name;let i = index" id="tag-{{ tag_list_id[ i ] }}">
										{{ ctVal }}
										<a href="javascript:;" (click)="removeFilter( $event, 'tags', tag_list_id[ i ], ctVal )" class="close-tags"><i class="icon-plus-heart"></i></a>
									</span>
								</div>
								<div class="tags selected__tags orgtype_block" *ngIf="showSelectedorgtype == true">
									<span class="tagFilter btn">
										ORG TYPE: {{ org_type_name }}
										<a href="javascript:;" (click)="removeFilter( $event, 'orgtype', org_type_id,  org_type_name )" class="close-tags"><i class="icon-plus-heart"></i></a>
									</span>
								</div>
								<div class="tags selected__tags basedin_block" *ngIf="showSelectedcontinent == true">
									<span class="tagFilter btn">
										BASED IN: {{ continent_name }}
										<a href="javascript:;" (click)="removeFilter( $event, 'continent', continent_id, continent_name )" class="close-tags"><i class="icon-plus-heart"></i></a>
									</span>
								</div>
								<div class="tags selected__tags basedin_block" *ngIf="showSelectedjobtitle == true">
									<span class="tagFilter btn">
										JOB TITLE: {{ job_title }}
										<a href="javascript:;" (click)="removeFilter( $event, 'jobtitle', job_id, job_title )" class="close-tags"><i class="icon-plus-heart"></i></a>
									</span>
								</div>
								<div class="tags selected__tags basedin_block" *ngIf="showSelectedprofessional == true">
									<span class="tagFilter btn">
										IS PROFESSIONAL: {{ professional_name }}
										<a href="javascript:;" (click)="removeFilter( $event, 'professional', professional_id, professional_name )" class="close-tags"> <i class="icon-plus-heart"></i></a>
									</span>
								</div>
								<div class="tags selected__tags basedin_block" *ngIf="showSelectedgender == true">
									<span class="tagFilter btn">
										GENDER: {{ gender_name }}
										<a href="javascript:;" (click)="removeFilter( $event, 'gender', gender_id, gender_name )" class="close-tags"><i class="icon-plus-heart"></i></a>
									</span>
								</div>
								<div class="tags selected__tags basedin_block" *ngIf="showSelectedinterview == true">
									<span class="tagFilter btn">
										OPEN TO INTERVIEW: {{ interview_name }}
										<a href="javascript:;" (click)="removeFilter( $event, 'interview', interview_id, interview_name )" class="close-tags"><i class="icon-plus-heart"></i></a>
									</span>
								</div>
								<div class="tags selected__tags basedin_block" *ngIf="showSelectedspeaker == true">
									<span class="tagFilter btn">
										IS SPEAKER: {{ speaker_name }}
										<a href="javascript:;" (click)="removeFilter( $event, 'speaker', speaker_id, speaker_name )" class="close-tags"><i class="icon-plus-heart"></i></a>
									</span>
								</div>
								<div class="tags selected__tags basedin_block" *ngIf="showSelectedmeeting == true">
									<span class="tagFilter btn">
										OPEN TO MEETING: {{ meeting_name }}
										<a href="javascript:;" (click)="removeFilter( $event, 'meeting', meeting_id, meeting_name )" class="close-tags"><i class="icon-plus-heart"></i></a>
									</span>
								</div>								
							</div>
							<span class="filtered-numbers float-right">{{ count }} {{ total }} Speakers</span>
						</div>
						<div class="page-intro" *ngIf="speakerData?.speaker_content != ''">
							<div class="preamble" [innerHtml]="speakerData?.speaker_content | safe:'preamble'"></div>
						</div>
						<div class="masonry-section masonry-section-js participants-grid row">
							<div class="grid-sizer-3"></div>
							<div class="col-12 col-sm-6 col-md-4 masonry-item participants-grid-item" *ngFor="let plVal of speakerList; let odd = odd; let even = even">
								<div class="news__link">
									<a class="masonry-link" routerLink="/community/participant/{{ plVal.slug }}">
										<div class="block-tag" *ngIf="plVal.country != ''">
											<b class="tag-head"></b>
											<span>{{ plVal.country }}</span>
										</div>
										<figure class="news__image" *ngIf="plVal?.photo">
											<img src="{{ plVal?.photo }}" alt="{{ plVal?.name }}" class="img-responsive" loading="lazy" />
										</figure>
										<figure class="news__image no-image {{ odd ? 'odd-list' : 'even-list' }}" *ngIf="!plVal.photo">
										</figure>
										<div class="news__content">
											<h3>{{ plVal.name | titlecase }}</h3>
											<p *ngIf="plVal?.position != '' || pVal?.organization != ''">
												<span class="working-as" *ngIf="plVal.position != ''">{{ plVal.position }}</span>
												<span class="working-at" *ngIf="plVal.organization != ''"><a href="javascript:void(0);" routerLink="/community/organization/{{ plVal.organizationslug }}">{{ plVal.organization }}</a></span>

												<span class="btn btn-press btn-circle" *ngIf="plVal.usertype == 'Press' || plVal.usertype == 'Communications'"><i class="icon-camera"></i> PRESS/COMMS</span>
											</p>
										</div>
									</a>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-12 text-center load-more link-wrapper load-more-large">
								<a href="javascript:;" class="btn btn-bluelight btn-circle link-more" (click)="loadMoreSpeaker()" *ngIf="!loadMoreButton && showMoreButton">Show More<span><i class="icon-breadcrumb-bottom"></i></span></a>		
								<span *ngIf="loadMoreButton"><span class="loading__circle loading__circle-small"></span></span>								
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</div>